import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-CJg44kCr.js';

const defaultTheme = stormLightTheme;

export { defaultTheme as d };
//# sourceMappingURL=index-C-fg_cAa.js.map
